import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";

/**
 * Dove vive la sessione di accesso.
 *
 * IL GUASTO (Davide, 31/08, dall'iPhone): «non resta l'accesso connesso
 * quando vado con Google». Dentro il guscio nativo la sessione stava nel
 * localStorage della vista web, e iOS quella memoria la puo' SVUOTARE
 * quando decide lui - pulizia di spazio, riavvii, criteri suoi. Risultato:
 * l'app che ti butta fuori a caso. E' il difetto piu' noto delle app
 * Capacitor con Supabase.
 *
 * LA CURA: sul telefono la sessione va nella memoria nativa dell'app
 * (Preferences: UserDefaults su iOS, SharedPreferences su Android), che il
 * sistema non tocca mai. Sul web resta il localStorage di sempre:
 * supabase-js accetta una memoria asincrona senza fare storie.
 *
 * MIGRAZIONE: chi era gia' dentro con la vecchia memoria non deve rifare
 * l'accesso - alla prima lettura, se il valore non e' ancora nella memoria
 * nativa ma c'e' nel localStorage, lo si sposta. Vale una volta sola.
 */
export function memoriaSessione():
  | Storage
  | {
      getItem: (k: string) => Promise<string | null>;
      setItem: (k: string, v: string) => Promise<void>;
      removeItem: (k: string) => Promise<void>;
    } {
  if (!Capacitor.isNativePlatform()) return localStorage;

  return {
    async getItem(chiave: string): Promise<string | null> {
      const { value } = await Preferences.get({ key: chiave });
      if (value !== null) return value;
      // Migrazione dalla vecchia memoria: una volta sola, poi vive qui.
      try {
        const vecchio = localStorage.getItem(chiave);
        if (vecchio !== null) {
          await Preferences.set({ key: chiave, value: vecchio });
          localStorage.removeItem(chiave);
          return vecchio;
        }
      } catch {
        // localStorage inaccessibile: pazienza, si riparte dal login.
      }
      return null;
    },
    async setItem(chiave: string, valore: string): Promise<void> {
      await Preferences.set({ key: chiave, value: valore });
    },
    async removeItem(chiave: string): Promise<void> {
      await Preferences.remove({ key: chiave });
    },
  };
}
